<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn :to="{ name: '_change_profile' }" icon width="40" height="40" class="mr-2">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.enter_new_phone_number') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <div class="mt-4">
              <div class="subtitle-splash">
                {{ $t('v2.new_phone_number') }}
              </div>
            </div>
            <div class="mt-2">
              <l-a-phone-number v-model="form.phone" :label="$t('fields.phone')" class="inputv2-space" />
            </div>
            <div class="section-bottom">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                    <v-btn block color="primary" height="40" class="text-none br-5" @click="sendOTP()">
                      {{ $t('v2.next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="dialog.limit_resend" content-class="dialog-icon">
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="mt-12 text-center mb-10">
                <img src="@/assets/images/v2/img/limit_resend.png" alt="Limit">
              </div>
              <div class="text-center">
                <div class="font-18 font-weight-700 ol-black mb-4">
                  {{ $t('v2.verification_reached_limit') }}
                </div>
                <div class="font-14 font-weight-400 ol-black mb-10" v-html="$t('v2.you_have_verified_several_times', { time: formatTimeLimit })" />
                <v-btn block color="white" class="br-5 text-none ol-elevation-1 font-weight-700 letter-spacing-normal" @click="dialog.limit_resend = false">
                  {{ $t('v2.cancel2') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import {
  ValidationObserver
} from 'vee-validate'
import {
  requestOTP
} from '@/api/auth'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    ValidationObserver,
    LAPhoneNumber
  },
  data() {
    return {
      dialog: {
        limit_resend: false
      },
      limit_time: 0,
      limitInterval: null,
      form: {
        phone: '',
        otp_type: 3,
        requestId: ''
      }
    }
  },
  computed: {
    formatTimeLimit() {
      let days = Math.floor(this.limit_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.limit_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.limit_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.limit_time % (1000 * 60)) / 1000)
      let result
      if (this.limit_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ':' : hours + ':'
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  watch: {
    formatTimeLimit: function(newItem) {
      if (newItem === 'EXPIRED' || newItem === '00:00') {
        this.dialog.limit_resend = false
      }
    }
  },
  methods: {
    async sendOTP() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          if (typeof this.$route.query.data !== 'undefined' && this.$route.query.data) {
            this.form.requestId = this.$route.query.data
          }
          const { data } = await requestOTP(this.form)
          const time = data.data.detail.expiry_date
          this.$router.push({ name: '_verification_phone', query: { type: 'new', otp_type: this.form.otp_type, phone: this.form.phone, expiry_date: time, data: data.requestId }}).catch(() => {})
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.code_sent_successfully')
          this.$store.state.error_type = 200
        } catch (e) {
          if (e.statusCode === 406 && e.error_tagging !== null) {
            try {
              this.form.otp_type = 1
              this.form.requestId = e.data.requestId
              const { data } = await requestOTP(this.form)
              const time = data.data.detail.expiry_date
              this.$router.push({ name: '_verification_phone', query: { redirect: this.$route.query.redirect, otp_type: this.form.otp_type, phone: this.form.phone, expiry_date: time }}).catch(() => {})
              this.$store.state.show_error = true
              this.$store.state.error_message = this.$t('v2.code_sent_successfully')
              this.$store.state.error_type = 200
            } catch (e) {
              if (e.statusCode === 429) {
                this.dialog.limit_resend = true
                this.getLimitTime(e.data.unlocked_in)
              } else {
                this.$store.state.show_error = true
                this.$store.state.error_message = e.string
                this.$store.state.error_type = e.statusCode
              }
            }
          } else if (e.statusCode === 429) {
            this.dialog.limit_resend = true
            this.getLimitTime(e.data.unlocked_in)
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        }
      }
    },
    getLimitTime(time) {
      const countDownDate = new Date(time).getTime()
      const _this = this
      this.limitInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.limit_time = countDownDate - now
        if (_this.limit_time < 0) {
          clearInterval(_this.limitInterval)
        }
      }, 1000)
    }
  }
}
</script>
